import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Servicio que centraliza el estado del sidebar.
// Maneja tres estados distintos: expandido (desktop), abierto en movil y con hover.
// Los componentes se suscriben a los observables para reaccionar a cada cambio.
@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isExpandedSubject = new BehaviorSubject<boolean>(true);
  private isMobileOpenSubject = new BehaviorSubject<boolean>(false);
  private isHoveredSubject = new BehaviorSubject<boolean>(false);

  isExpanded$ = this.isExpandedSubject.asObservable();
  isMobileOpen$ = this.isMobileOpenSubject.asObservable();
  isHovered$ = this.isHoveredSubject.asObservable();

  // Establece si el sidebar esta expandido en desktop
  setExpanded(val: boolean) {
    this.isExpandedSubject.next(val);
  }

  // Alterna entre expandido y colapsado
  toggleExpanded() {
    this.isExpandedSubject.next(!this.isExpandedSubject.value);
  }

  // Controla la visibilidad del sidebar en pantallas moviles
  setMobileOpen(val: boolean) {
    this.isMobileOpenSubject.next(val);
  }

  toggleMobileOpen() {
    this.isMobileOpenSubject.next(!this.isMobileOpenSubject.value);
  }

  // Se activa cuando el cursor entra al sidebar colapsado para mostrarlo temporalmente
  setHovered(val: boolean) {
    this.isHoveredSubject.next(val);
  }
}
